export const getResizeOrientation = ({ width, height }) => {
  const ratio = Number(width) / Number(height);
  if (ratio >= 0.85 && ratio <= 1.25) return 'square';
  return ratio > 1 ? 'horizontal' : 'vertical';
};

export const getClosestResizeReference = (dimension, references) => {
  const orientation = getResizeOrientation(dimension);
  const targetRatio = dimension.width / dimension.height;

  return references
    .filter(reference => reference.orientation === orientation)
    .reduce((closest, reference) => {
      if (!closest) return reference;
      const difference = Math.abs(Math.log((reference.width / reference.height) / targetRatio));
      const closestDifference = Math.abs(Math.log((closest.width / closest.height) / targetRatio));
      return difference < closestDifference ? reference : closest;
    }, null);
};
